/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ScheduledChangeDetailAppliedVersion } from './scheduledChangeDetailAppliedVersion';
import type { ScheduledChangeVisibleState } from './scheduledChangeVisibleState';
import type { ScheduledChangeDetailGoLiveAt } from './scheduledChangeDetailGoLiveAt';
import type { ScheduledQuestion } from './scheduledQuestion';
import type { ScheduledChangeDetailWorkingMode } from './scheduledChangeDetailWorkingMode';

export interface ScheduledChangeDetail {
  id: string;
  kind: string;
  moduleId: string;
  moduleTitle: string;
  version: string;
  appliedVersion?: ScheduledChangeDetailAppliedVersion;
  state: ScheduledChangeVisibleState;
  goLiveAt?: ScheduledChangeDetailGoLiveAt;
  stateChangedAt: string;
  questionCount: number;
  alternativesLeft: number;
  questions: ScheduledQuestion[];
  emptyTopics?: string[];
  workingMode?: ScheduledChangeDetailWorkingMode;
  etag: string;
}
